export default __webpack_public_path__ + "b23f37be07d6e42ed597a3f75583b435.svg";